// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ced293f5","453":"6d4a2d1d","455":"c33dcc41"}[chunkId] + ".chunk.js";
};